import GetTicketCodeButton from './GetTicketCodeButton';

export default GetTicketCodeButton;
